if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      connectedCallback() {
        super.connectedCallback?.();

        if (!Antonioli.settings.isDesktop) {
          this.swiperInstance = this.querySelector('.zoom-slider').swiper;

          this.swiperInstance?.on('slideChange', () => {
            this.thumbnailsSlider?.slideTo(this.swiperInstance.activeIndex);
          });

          this.thumbnailsSlider = new Swiper(this.querySelector('#thumbnails-mobile'), {
            slideToClickedSlide: true,
            on: {
              slideChange: () => {
                if (this.swiperInstance && this.thumbnailsSlider.activeIndex !== this.swiperInstance.activeIndex) {
                  this.swiperInstance.slideTo(this.thumbnailsSlider.activeIndex);
                }
              }
            }
          });
        } else {
          this.querySelector('swiper-slider .swiper-wrapper').addEventListener('click', () => this.hide());
        }
      }

      hide() {
        super.hide();
        document.querySelectorAll('.product__media video').forEach(v => v.play());
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        const mediaId = this.openedBy.getAttribute('data-media-id');
        const target = this.querySelector(`#product-media-${mediaId}, #full-look-zoom`);
        const indexCurrent = parseInt(document.querySelector('#product-media-list .swiper-slide-active')?.getAttribute('real-index')) - 1;

        if (!target) return;

        if (Antonioli.settings.isDesktop) {
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } else {
          this.swiperInstance?.slideTo(indexCurrent);
        }
      }
    }
  );
}